import { Injectable, Inject } from '@angular/core'
import { Http, Response, URLSearchParams } from '@angular/http'
import { Subject, Observable } from 'rxjs/Rx'
import { APP_CONFIG, IAppConfig } from '../../app.config'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Helpers } from './helpers'
import { TokenBase } from './token-base'
import { NgxPermissionsService } from 'ngx-permissions'
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class RefreshTokenService extends TokenBase {
    /*
        offset seconds
    */
    private offsetSeconds: number = 1000;

    constructor(public http: HttpClient, @Inject(APP_CONFIG) public config: IAppConfig, public permissionsService: NgxPermissionsService, private authHttp: AuthHttp) {
        super(http, config, permissionsService);
    }

    getNewToken(): Observable<any> {
        console.log("getNewToken");

        let path = this.config.apiEndpoint + "RefreshToken";
        let refreshToken: string | null = Helpers.getSessionStorage('refresh_token');
        let request: any = {
            refreshToken: refreshToken
        };

        console.log(request);

        return this.http.post(path, request)
            .map((response: any) => {
                let res: any = response;
                if (typeof res.accessToken !== 'undefined') {
                    this.store(res);
                }
            }).catch(this.handleError);
    }

    /* Optional strategy for refresh token through a scheduler.
     * Will schedule a refresh at the appropriate time.
     */
    public scheduleRefresh(): void {
        console.log("scheduleRefresh");

        const source = this.authHttp.tokenStream.flatMap(
            (token: string) => {
                let delay: number = Helpers.getExp() - (this.offsetSeconds * 1000);
                return Observable.interval(delay);
            });

        this.refreshSubscription = source.subscribe(() => {
            const token: string | null = Helpers.getSessionStorage('id_token');
            if (token != null) {
                this.getNewToken().subscribe(
                    () => {
                        // Scheduler works.
                    },
                    (error: any) => {
                        // Need to handle this error.
                        console.log(error);
                    }
                );
            }
            else {
                // Unschedules the refresh token.
                this.unscheduleRefresh();
            }
        });
    }

    /**
     * Case when the user comes back to the app after closing it.
     */
    public startupTokenRefresh(): void {
        // If the user is authenticated, uses the token stream
        // provided by angular2-jwt and flatMap the token.
        
        const source = this.authHttp.tokenStream.flatMap(
            (token: string) => {
                //const now: number = new Date().valueOf();
                let exp: number = Helpers.getExp();
                let delay: number = exp - (this.offsetSeconds * 1000);

                this.userInfo(token);

                // Uses the delay in a timer to run the refresh at the proper time.
                return Observable.timer(delay);
            });

        // Once the delay time from above is reached, gets a new JWT and schedules additional refreshes.
        source.subscribe(() => {
            this.getNewToken().subscribe(
                () => {
                    this.scheduleRefresh();
                },
                (error: any) => {
                    // Need to handle this error.
                    console.log(error);
                }
            );
        });
    }

    /**
     * Unsubscribes from the scheduling of the refresh token.
     */
    public unscheduleRefresh(): void {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}